import { InjectionToken, EventEmitter, Directive, forwardRef, ElementRef, Renderer2, Inject, Input, HostListener, Injectable, Component, ChangeDetectionStrategy, ChangeDetectorRef, Output, ContentChildren, ViewChild, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormControl, Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { TinyColor } from '@thebespokepixel/es-tinycolor';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

/** Contant used as empty color */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/material/button';
import * as ɵngcc3 from '@angular/cdk/portal';
import * as ɵngcc4 from '@angular/cdk/overlay';
import * as ɵngcc5 from '@angular/forms';
import * as ɵngcc6 from '@angular/material/form-field';
import * as ɵngcc7 from '@angular/material/input';
import * as ɵngcc8 from '@angular/material/icon';

function MccColorPickerCollectionComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 3);
    ɵngcc0.ɵɵlistener("click", function MccColorPickerCollectionComponent_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r2.setTransparent()); });
    ɵngcc0.ɵɵelement(1, "span", 4);
    ɵngcc0.ɵɵelementEnd();
} }
function MccColorPickerCollectionComponent_mcc_color_picker_option_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mcc-color-picker-option", 5);
    ɵngcc0.ɵɵlistener("colorSelected", function MccColorPickerCollectionComponent_mcc_color_picker_option_4_Template_mcc_color_picker_option_colorSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.setColor($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const color_r4 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("color", color_r4)("selectedColor", ctx_r1.selectedColor);
} }
function MccColorPickerComponent_ng_container_0_ng_template_4_ng_template_0_Template(rf, ctx) { }
function MccColorPickerComponent_ng_container_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MccColorPickerComponent_ng_container_0_ng_template_4_ng_template_0_Template, 0, 0, "ng-template", 7);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("cdkPortalOutlet", _r2);
} }
const _c0 = function (a0, a1) { return { empty: a0, disabled: a1 }; };
function MccColorPickerComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 3, 4);
    ɵngcc0.ɵɵlistener("click", function MccColorPickerComponent_ng_container_0_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r7.toggle()); });
    ɵngcc0.ɵɵelement(3, "span", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, MccColorPickerComponent_ng_container_0_ng_template_4_Template, 1, 1, "ng-template", 6);
    ɵngcc0.ɵɵlistener("backdropClick", function MccColorPickerComponent_ng_container_0_Template_ng_template_backdropClick_4_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r9.backdropClick()); });
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r4 = ɵngcc0.ɵɵreference(2);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(5, _c0, ctx_r0.selectedColor === ctx_r0.emptyColor, ctx_r0.disabled));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵstyleProp("background-color", ctx_r0.selectedColor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdkConnectedOverlayOrigin", _r4)("cdkConnectedOverlayOpen", ctx_r0.isOpen);
} }
function MccColorPickerComponent_1_ng_template_0_Template(rf, ctx) { }
function MccColorPickerComponent_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MccColorPickerComponent_1_ng_template_0_Template, 0, 0, "ng-template", 7);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("cdkPortalOutlet", _r2);
} }
function MccColorPickerComponent_ng_template_2_mcc_color_picker_selector_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mcc-color-picker-selector", 11);
    ɵngcc0.ɵɵlistener("changeSelectedColor", function MccColorPickerComponent_ng_template_2_mcc_color_picker_selector_1_Template_mcc_color_picker_selector_changeSelectedColor_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r15.updateTmpSelectedColor($event)); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("selectedColor", ɵngcc0.ɵɵpipeBind1(1, 3, ctx_r11.tmpSelectedColor$))("hideHexForms", ctx_r11.hideHexForms)("height", ctx_r11.colorPickerSelectorHeight);
} }
function MccColorPickerComponent_ng_template_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "mcc-color-picker-collection", 12);
    ɵngcc0.ɵɵlistener("changeColor", function MccColorPickerComponent_ng_template_2_ng_container_2_Template_mcc_color_picker_collection_changeColor_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r17.updateTmpSelectedColor($event)); });
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("label", ctx_r12.usedColorLabel)("size", ctx_r12.usedSizeColors)("transparent", !ctx_r12.hideTransparent)("hideEmpty", ctx_r12.hideEmpty)("colors", ɵngcc0.ɵɵpipeBind1(2, 5, ctx_r12.usedColors$));
} }
function MccColorPickerComponent_ng_template_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "mcc-color-picker-collection", 12);
    ɵngcc0.ɵɵlistener("changeColor", function MccColorPickerComponent_ng_template_2_ng_container_4_Template_mcc_color_picker_collection_changeColor_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r19.updateTmpSelectedColor($event)); });
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("label", ctx_r13.usedColorLabel)("size", ctx_r13.usedSizeColors)("transparent", !ctx_r13.hideTransparent)("hideEmpty", ctx_r13.hideEmpty)("colors", ɵngcc0.ɵɵpipeBind1(2, 5, ctx_r13.usedColors$));
} }
function MccColorPickerComponent_ng_template_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelement(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "button", 15);
    ɵngcc0.ɵɵlistener("click", function MccColorPickerComponent_ng_template_2_div_5_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r21.cancelSelection()); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 16);
    ɵngcc0.ɵɵlistener("click", function MccColorPickerComponent_ng_template_2_div_5_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r23.confirmSelectedColor()); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r14.btnCancelLabel, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r14.btnConfirmLabel, " ");
} }
const _c1 = function (a0) { return { "alpha-enabled": a0 }; };
function MccColorPickerComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtemplate(1, MccColorPickerComponent_ng_template_2_mcc_color_picker_selector_1_Template, 2, 5, "mcc-color-picker-selector", 9);
    ɵngcc0.ɵɵtemplate(2, MccColorPickerComponent_ng_template_2_ng_container_2_Template, 3, 7, "ng-container", 0);
    ɵngcc0.ɵɵprojection(3);
    ɵngcc0.ɵɵtemplate(4, MccColorPickerComponent_ng_template_2_ng_container_4_Template, 3, 7, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(5, MccColorPickerComponent_ng_template_2_div_5_Template, 6, 2, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c1, ctx_r3.alpha));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.hideColorPickerSelector);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.hideUsedColors && ctx_r3.usedColorsPosition == "top");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.hideUsedColors && ctx_r3.usedColorsPosition == "bottom");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.hideButtons);
} }
const _c2 = ["*"];
const _c3 = ["hueContainer"];
const _c4 = ["block"];
const _c5 = ["blockPointer"];
const _c6 = ["blockCanvas"];
const _c7 = ["hueSelector"];
const _c8 = ["alpha"];
const _c9 = ["alphaContainer"];
function MccColorPickerSelectorComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15, 16);
    ɵngcc0.ɵɵelement(2, "canvas", 17, 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("height", ctx_r5.height, "px");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("height", ctx_r5.stripHeight)("width", ctx_r5.stripWidth);
} }
function MccColorPickerSelectorComponent_ng_container_15_mat_form_field_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-form-field", 22);
    ɵngcc0.ɵɵelement(1, "input", 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r9.textClass);
} }
function MccColorPickerSelectorComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "form", 19)(2, "mat-form-field", 20);
    ɵngcc0.ɵɵelement(3, "input", 21);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(4, "form", 19)(5, "mat-form-field", 22);
    ɵngcc0.ɵɵelement(6, "input", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "mat-form-field", 22);
    ɵngcc0.ɵɵelement(8, "input", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "mat-form-field", 22);
    ɵngcc0.ɵɵelement(10, "input", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, MccColorPickerSelectorComponent_ng_container_15_mat_form_field_11_Template, 2, 1, "mat-form-field", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r6.hexForm);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r6.textClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r6.rgbaForm);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r6.textClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r6.colorPickerCollectionService.alpha ? "RGBA" : "RGB");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r6.textClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r6.textClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.colorPickerCollectionService.alpha);
} }
const _c10 = function (a0) { return { "height.px": a0 }; };
const _c11 = ["button"];
function MccColorPickerOptionComponent_ng_container_3_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-icon");
} }
function MccColorPickerOptionComponent_ng_container_3_ng_template_2_mat_icon_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-icon", 8);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("svgIcon", ctx_r5.selectedColorSvgIcon)("ngClass", ctx_r5.getIconColorClassForColor(ctx_r5.color));
} }
function MccColorPickerOptionComponent_ng_container_3_ng_template_2_ng_template_1_mat_icon_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r8.getIconColorClassForColor(ctx_r8.color));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.selectedColorIcon);
} }
function MccColorPickerOptionComponent_ng_container_3_ng_template_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MccColorPickerOptionComponent_ng_container_3_ng_template_2_ng_template_1_mat_icon_0_Template, 2, 2, "mat-icon", 9);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r7.selectedColorSvgIcon);
} }
function MccColorPickerOptionComponent_ng_container_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MccColorPickerOptionComponent_ng_container_3_ng_template_2_mat_icon_0_Template, 1, 2, "mat-icon", 6);
    ɵngcc0.ɵɵtemplate(1, MccColorPickerOptionComponent_ng_container_3_ng_template_2_ng_template_1_Template, 1, 1, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r6 = ɵngcc0.ɵɵreference(2);
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.selectedColorSvgIcon)("ngIfElse", _r6);
} }
function MccColorPickerOptionComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MccColorPickerOptionComponent_ng_container_3_mat_icon_1_Template, 1, 0, "mat-icon", 4);
    ɵngcc0.ɵɵtemplate(2, MccColorPickerOptionComponent_ng_container_3_ng_template_2_Template, 3, 2, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r3 = ɵngcc0.ɵɵreference(3);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.isColorSelected(ctx_r1.color))("ngIfElse", _r3);
} }
const EMPTY_COLOR = new InjectionToken('empty-color');
/** Constante to set usedColorStart from the module import */
const USED_COLORS = new InjectionToken('used-colors');
/** Customize selected color icon */
const SELECTED_COLOR_ICON = new InjectionToken('selected-color-icon');
/** Customize selected color svg icon */
const SELECTED_COLOR_SVG_ICON = new InjectionToken('selected-color-svg-icon');
/** Disable selected color icon */
const DISABLE_SELECTED_COLOR_ICON = new InjectionToken('disable-selected-color-icon');
/** Enable alpha selector **/
const ENABLE_ALPHA_SELECTOR = new InjectionToken('enable-alpha-selector');
/** Format used for color strings **/
const COLOR_STRING_FORMAT = new InjectionToken('color-string-format');

/**
 * parses a string-representation of a color with tinycolor - returns "null" when not a valid string
 */
function parseColorString(colorString) {
    const color = new TinyColor(colorString);
    if (color.isValid()) {
        return color;
    }
    else {
        return null;
    }
}
/**
 * converts a TinyColor instance to format "#FFFFFF' or "#FFFFFFFF" with alpha < 1
 */
function toHex(color) {
    if (!color) {
        return null;
    }
    if (color.getAlpha() < 1) {
        return color.toHex8String().toUpperCase();
    }
    else {
        return color.toHexString().toUpperCase();
    }
}
/**
 * converts a TinyColor instance to format "rgb(255, 255, 255)" when color has no alpha value and "rgba(255, 255, 255, 0.5)" when alpha < 1
 */
function toRgb(color) {
    if (!color) {
        return null;
    }
    return color.toRgbString();
}
/**
 * converts a TinyColor instance to format "hsl(360, 100%, 100%)" when color has no alpha value and "hsla(360, 100%, 100%, 0.5)" when alpha < 1
 */
function toHsl(color) {
    if (!color) {
        return null;
    }
    return color.toHslString();
}
/**
 * converts a TinyColor instance to certain format
 */
function formatColor(color, format) {
    switch (format) {
        case 'hex':
            return toHex(color);
        case 'rgb':
            return toRgb(color);
        case 'hsl':
            return toHsl(color);
    }
}

/**
 * Directive applied to an element to make it usable as an origin for an ColorPicker.
 */
class MccColorPickerOriginDirective {
    constructor(elementRef, renderer, emptyColor) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.emptyColor = emptyColor;
        /**
         * Emit focus event
         */
        this.hasFocus = new EventEmitter();
        /**
         * Emit changes from the origin
         */
        this.change = new BehaviorSubject(this.elementRef.nativeElement.value);
        /**
         * Controls if focus of the input opens the color picker dialog
         */
        this.openMode = 'default';
    }
    onFocus() {
        if (this.openMode === 'openOnFocus') {
            this.hasFocus.emit();
        }
    }
    onKeyup() {
        const value = this.elementRef.nativeElement.value;
        if (!value) {
            this.writeValueFromKeyup(this.emptyColor);
        }
        else {
            const color = parseColorString(value);
            if (color) {
                this.writeValueFromKeyup(value);
            }
        }
    }
    /**
     * This method will be called by the forms API to write to the view when
     * programmatic (model -> view) changes are requested.
     */
    writeValue(color) {
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', color);
        this.change.next(color);
        if (this.propagateChanges) {
            this.propagateChanges(color);
        }
    }
    /**
     * This method will be called by the color picker
     */
    writeValueFromColorPicker(color) {
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', color);
        this.propagateChanges(color);
    }
    /**
     * This method will be called from origin whe key is up
     */
    writeValueFromKeyup(color) {
        this.change.next(color);
        this.propagateChanges(color);
    }
    /**
     * This is called by the forms API on initialization so it can update the
     * form model when values propagate from the view (view -> model).
     */
    registerOnChange(fn) {
        this.propagateChanges = fn;
    }
    /**
     * This is called by the forms API on initialization so it can update the form model on blur
     */
    registerOnTouched(fn) { }
    /**
     * called by the forms API when the control status changes to or from "DISABLED"
     */
    setDisabledState(isDisabled) {
        this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    }
}
MccColorPickerOriginDirective.ɵfac = function MccColorPickerOriginDirective_Factory(t) { return new (t || MccColorPickerOriginDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(EMPTY_COLOR)); };
MccColorPickerOriginDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MccColorPickerOriginDirective, selectors: [["", "mcc-color-picker-origin", ""], ["", "mccColorPickerOrigin", ""]], hostBindings: function MccColorPickerOriginDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function MccColorPickerOriginDirective_focus_HostBindingHandler() { return ctx.onFocus(); })("keyup", function MccColorPickerOriginDirective_keyup_HostBindingHandler() { return ctx.onKeyup(); });
    } }, inputs: { openMode: ["mccColorPickerOrigin", "openMode"] }, exportAs: ["mccColorPickerOrigin"], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MccColorPickerOriginDirective),
                multi: true
            }
        ])] });
MccColorPickerOriginDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: String, decorators: [{ type: Inject, args: [EMPTY_COLOR,] }] }
];
MccColorPickerOriginDirective.propDecorators = {
    openMode: [{ type: Input, args: ['mccColorPickerOrigin',] }],
    onFocus: [{ type: HostListener, args: ['focus',] }],
    onKeyup: [{ type: HostListener, args: ['keyup',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MccColorPickerOriginDirective, [{
        type: Directive,
        args: [{
                selector: '[mcc-color-picker-origin], [mccColorPickerOrigin]',
                exportAs: 'mccColorPickerOrigin',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MccColorPickerOriginDirective),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: String, decorators: [{
                type: Inject,
                args: [EMPTY_COLOR]
            }] }]; }, { openMode: [{
            type: Input,
            args: ['mccColorPickerOrigin']
        }], onFocus: [{
            type: HostListener,
            args: ['focus']
        }], onKeyup: [{
            type: HostListener,
            args: ['keyup']
        }] }); })();

class MccColorPickerCollectionService {
    constructor(emptyColor) {
        this.emptyColor = emptyColor;
        /**
         * Hold current selected color
         */
        this._selectedColor = new BehaviorSubject('');
    }
    /**
     * Change internal selected color
     */
    changeSelectedColor(colorString) {
        if (colorString === this.emptyColor) {
            this._selectedColor.next(colorString);
        }
        const color = parseColorString(colorString);
        if (!colorString || !color) {
            return;
        }
        const clrString = formatColor(color, this.format);
        this._selectedColor.next(clrString);
    }
    /**
     * Return internal selected color
     */
    getSelectedColor() {
        return this._selectedColor.asObservable();
    }
}
MccColorPickerCollectionService.ɵfac = function MccColorPickerCollectionService_Factory(t) { return new (t || MccColorPickerCollectionService)(ɵngcc0.ɵɵinject(EMPTY_COLOR)); };
MccColorPickerCollectionService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: MccColorPickerCollectionService, factory: MccColorPickerCollectionService.ɵfac });
MccColorPickerCollectionService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [EMPTY_COLOR,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MccColorPickerCollectionService, [{
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [EMPTY_COLOR]
            }] }]; }, null); })();

class MccColorPickerCollectionComponent {
    constructor(changeDetectorRef, colorPickerCollectionService, emptyColor) {
        this.changeDetectorRef = changeDetectorRef;
        this.colorPickerCollectionService = colorPickerCollectionService;
        this.emptyColor = emptyColor;
        this._hideEmpty = false;
        /**
         * Size limit of the collection
         */
        this.size = 30;
        this._transparent = false;
        /**
         * Emit selected color value
         */
        this.changeColor = new EventEmitter();
    }
    /**
     * Hide empty slots
     * Empty slots are the difference between the collection size and limit
     */
    set hideEmpty(value) {
        this._hideEmpty = coerceBooleanProperty(value);
    }
    /**
     * Name of the collection
     */
    get label() {
        return this._label;
    }
    set label(value) {
        this._label = value;
    }
    /**
     * Array of colors to be displayed
     */
    get colors() {
        return this._colors;
    }
    set colors(values) {
        // map color string from user to string based on configured format
        const colors = [];
        values.forEach(value => {
            if (typeof value === 'string') {
                const clr = parseColorString(value);
                if (clr) {
                    colors.push(formatColor(clr, this.colorPickerCollectionService.format));
                }
            }
            else {
                const clr = value ? parseColorString(value.value) : null;
                if (clr) {
                    colors.push({ value: formatColor(clr, this.colorPickerCollectionService.format), text: value.text });
                }
            }
        });
        this._colors = colors;
    }
    /**
     * Show transparent option
     */
    set transparent(value) {
        this._transparent = coerceBooleanProperty(value);
    }
    get transparent() {
        return this._transparent;
    }
    /**
     * Current selected color
     */
    get selectedColor() {
        return this._selectedColor;
    }
    ngOnInit() {
        // get current selected color
        this.colorPickerCollectionService.getSelectedColor().subscribe(color => {
            this._selectedColor = color;
            this.changeDetectorRef.detectChanges();
        });
    }
    ngAfterContentChecked() {
        if (this._colors && this._colors.length !== this.size) {
            this._colors = this._colors.slice(0, this.size).concat(new Array(this._getCollectionDiffSize()));
            this.changeDetectorRef.markForCheck();
        }
    }
    /**
     * Return the difference between the limit and the collection size.
     * Always return 0 when hideEmpty is true
     */
    _getCollectionDiffSize() {
        if (this._colors.length > this.size || this._hideEmpty) {
            return 0;
        }
        return this.size - this._colors.length;
    }
    /**
     * Remove color
     */
    setTransparent() {
        this.changeColor.emit(this.emptyColor);
    }
    /**
     * Emit selected color value
     */
    setColor(option) {
        const color = typeof option === 'string' ? option : option.value;
        this.colorPickerCollectionService.changeSelectedColor(color);
        this.changeColor.emit(color);
    }
}
MccColorPickerCollectionComponent.ɵfac = function MccColorPickerCollectionComponent_Factory(t) { return new (t || MccColorPickerCollectionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(MccColorPickerCollectionService), ɵngcc0.ɵɵdirectiveInject(EMPTY_COLOR)); };
MccColorPickerCollectionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MccColorPickerCollectionComponent, selectors: [["mcc-color-picker-collection"]], inputs: { size: "size", hideEmpty: "hideEmpty", label: "label", colors: "colors", transparent: "transparent" }, outputs: { changeColor: "changeColor" }, decls: 5, vars: 3, consts: [["role", "listbox", "aria-label", "Select a color", 1, "mcc-color-picker-collection"], ["mat-mini-fab", "", "class", "mcc-color-picker-remove-color mat-elevation-z0", "role", "option", "aria-label", "transparent", 3, "click", 4, "ngIf"], [3, "color", "selectedColor", "colorSelected", 4, "ngFor", "ngForOf"], ["mat-mini-fab", "", "role", "option", "aria-label", "transparent", 1, "mcc-color-picker-remove-color", "mat-elevation-z0", 3, "click"], [1, "mcc-color-picker-transparent"], [3, "color", "selectedColor", "colorSelected"]], template: function MccColorPickerCollectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "h3");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, MccColorPickerCollectionComponent_button_3_Template, 2, 0, "button", 1);
        ɵngcc0.ɵɵtemplate(4, MccColorPickerCollectionComponent_mcc_color_picker_option_4_Template, 1, 2, "mcc-color-picker-option", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.transparent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.colors);
    } }, dependencies: function () { return [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc2.MatButton, MccColorPickerOptionComponent]; }, styles: ["button[_ngcontent-%COMP%]{cursor:pointer;height:22px;margin:3px;width:22px}.mcc-color-picker-collection[_ngcontent-%COMP%]{min-height:50px;padding:10px 18px}.mcc-color-picker-collection[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{color:rgba(0,0,0,.87);font-size:12px;font-weight:700;margin:0 0 10px;text-transform:uppercase}.mcc-color-picker-remove-color[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #e1e1e1}.mcc-color-picker-remove-color[_ngcontent-%COMP%]   .mcc-color-picker-transparent[_ngcontent-%COMP%]{-webkit-transform:translateY(-4px) translateX(0) rotate(45deg);border-bottom:1px solid red;display:block;height:1px;transform:translateY(-4px) translateX(0) rotate(45deg);width:20px}"], changeDetection: 0 });
MccColorPickerCollectionComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: MccColorPickerCollectionService },
    { type: String, decorators: [{ type: Inject, args: [EMPTY_COLOR,] }] }
];
MccColorPickerCollectionComponent.propDecorators = {
    hideEmpty: [{ type: Input }],
    label: [{ type: Input }],
    colors: [{ type: Input }],
    size: [{ type: Input }],
    transparent: [{ type: Input }],
    changeColor: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MccColorPickerCollectionComponent, [{
        type: Component,
        args: [{ selector: 'mcc-color-picker-collection', template: "<div class=\"mcc-color-picker-collection\" role=\"listbox\" aria-label=\"Select a color\">\n  <h3>{{ label }}</h3>\n\n  <button\n    mat-mini-fab\n    *ngIf=\"transparent\"\n    class=\"mcc-color-picker-remove-color mat-elevation-z0\"\n    role=\"option\"\n    aria-label=\"transparent\"\n    (click)=\"setTransparent()\"\n  >\n    <span class=\"mcc-color-picker-transparent\"></span>\n  </button>\n\n  <mcc-color-picker-option\n    *ngFor=\"let color of colors\"\n    [color]=\"color\"\n    [selectedColor]=\"selectedColor\"\n    (colorSelected)=\"setColor($event)\"\n  >\n  </mcc-color-picker-option>\n</div>\n", preserveWhitespaces: false, changeDetection: ChangeDetectionStrategy.OnPush, styles: ["button{cursor:pointer;height:22px;margin:3px;width:22px}.mcc-color-picker-collection{min-height:50px;padding:10px 18px}.mcc-color-picker-collection h3{color:rgba(0,0,0,.87);font-size:12px;font-weight:700;margin:0 0 10px;text-transform:uppercase}.mcc-color-picker-remove-color{background-color:#fff;border:1px solid #e1e1e1}.mcc-color-picker-remove-color .mcc-color-picker-transparent{-webkit-transform:translateY(-4px) translateX(0) rotate(45deg);border-bottom:1px solid red;display:block;height:1px;transform:translateY(-4px) translateX(0) rotate(45deg);width:20px}"] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: MccColorPickerCollectionService }, { type: String, decorators: [{
                type: Inject,
                args: [EMPTY_COLOR]
            }] }]; }, { size: [{
            type: Input
        }], changeColor: [{
            type: Output
        }], hideEmpty: [{
            type: Input
        }], label: [{
            type: Input
        }], colors: [{
            type: Input
        }], transparent: [{
            type: Input
        }] }); })();

class MccColorPickerService {
    constructor(emptyColor, usedColors) {
        this.emptyColor = emptyColor;
        this.usedColors = usedColors;
        /**
         * Array of all used colors
         */
        this._usedColors = new BehaviorSubject([]);
        // map color string from user to string based on configured format
        const colors = [];
        usedColors.forEach(value => {
            const clr = parseColorString(value);
            if (clr) {
                colors.push(value);
            }
        });
        this._usedColors.next(colors);
    }
    /**
     * Add new color to used colors
     */
    addColor(colorString) {
        const color = parseColorString(colorString);
        if (!colorString || !color) {
            return;
        }
        const usedColors = this._usedColors.getValue();
        if (!usedColors.includes(colorString)) {
            usedColors.push(colorString);
            this._usedColors.next(usedColors);
        }
    }
    /**
     * Return Observable of colors
     */
    getUsedColors() {
        return this._usedColors.asObservable();
    }
    /**
     * Reset the array of used colors
     */
    resetUsedColors() {
        this._usedColors.next([]);
    }
}
MccColorPickerService.ɵfac = function MccColorPickerService_Factory(t) { return new (t || MccColorPickerService)(ɵngcc0.ɵɵinject(EMPTY_COLOR), ɵngcc0.ɵɵinject(USED_COLORS)); };
MccColorPickerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: MccColorPickerService, factory: MccColorPickerService.ɵfac });
MccColorPickerService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [EMPTY_COLOR,] }] },
    { type: Array, decorators: [{ type: Inject, args: [USED_COLORS,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MccColorPickerService, [{
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [EMPTY_COLOR]
            }] }, { type: Array, decorators: [{
                type: Inject,
                args: [USED_COLORS]
            }] }]; }, null); })();

class MccColorPickerComponent {
    constructor(elementRef, changeDetectorRef, colorPickerService, colorPickerCollectionService, emptyColor, showAlphaSelector, colorStringFormat) {
        this.elementRef = elementRef;
        this.changeDetectorRef = changeDetectorRef;
        this.colorPickerService = colorPickerService;
        this.colorPickerCollectionService = colorPickerCollectionService;
        this.emptyColor = emptyColor;
        this._disabled = false;
        this._usedColorLabel = 'Used Colors';
        this._reverseUsedColor = false;
        this._usedColorsPosition = 'top';
        this._hideHexForms = false;
        this._hideEmpty = false;
        this._hideTransparent = false;
        this._hideUsedColors = false;
        this._isOpen = false;
        this._overlay = true;
        this._hideButtons = false;
        this._colorPickerSelectorHeight = 170;
        this._hideColorPickerSelector = false;
        /**
         * Set the size of the used colors
         */
        this.usedSizeColors = 30;
        /**
         * Change btnCancel label
         */
        this.btnCancelLabel = 'Cancel';
        /**
         * Change btnConfirm label
         */
        this.btnConfirmLabel = 'Confirm';
        this._alpha = false;
        /**
         * Event emitted when user change the selected color (without confirm)
         */
        this.change = new EventEmitter();
        /**
         * Event emitted when selected color is confirm
         */
        this.selected = new EventEmitter();
        /**
         * Event emitted when is clicked outside of the component
         */
        this.clickOut = new EventEmitter();
        /**
         * Event emitted when is clicked outside of the component
         */
        this.canceled = new EventEmitter();
        /**
         * Array of subscriptions from the collections
         */
        this._collectionSubs = [];
        this._alpha = showAlphaSelector;
        this.format = colorStringFormat;
    }
    /**
     * Disable color-picker of showing up
     */
    set disabled(disabled) {
        this._disabled = coerceBooleanProperty(disabled);
    }
    get disabled() {
        return this._disabled;
    }
    /**
     * Change label of the collection UsedColors
     */
    get usedColorLabel() {
        return this._usedColorLabel;
    }
    set usedColorLabel(value) {
        this._usedColorLabel = value;
    }
    /**
     * Set initial value for used color
     */
    set usedColorStart(colors) {
        if (colors && colors.length > 0) {
            for (const color of colors) {
                this.colorPickerService.addColor(color);
            }
        }
    }
    /**
     * Set usedColor to be used in reverse
     */
    set reverseUsedColors(reverse) {
        this._reverseUsedColor = coerceBooleanProperty(reverse);
    }
    get reverseUsedColors() {
        return this._reverseUsedColor;
    }
    /**
     * Set position of used colors collection
     */
    set usedColorsPosition(position) {
        this._usedColorsPosition = position;
    }
    get usedColorsPosition() {
        return this._usedColorsPosition;
    }
    /**
     * Hide the hexadecimal color forms.
     */
    set hideHexForms(value) {
        this._hideHexForms = coerceBooleanProperty(value);
    }
    get hideHexForms() {
        return this._hideHexForms;
    }
    /**
     * Hide empty slots from the collection UsedColors
     */
    set hideEmpty(value) {
        this._hideEmpty = coerceBooleanProperty(value);
    }
    get hideEmpty() {
        return this._hideEmpty;
    }
    /**
     * Hide transparent option of UsedColors
     */
    set hideTransparent(value) {
        this._hideTransparent = coerceBooleanProperty(value);
    }
    get hideTransparent() {
        return this._hideTransparent;
    }
    /**
     * Hide UsedColors collection
     */
    set hideUsedColors(value) {
        this._hideUsedColors = coerceBooleanProperty(value);
    }
    get hideUsedColors() {
        return this._hideUsedColors;
    }
    /**
     * Start with a color selected
     */
    get selectedColor() {
        return this._selectedColor;
    }
    set selectedColor(value) {
        if (this._selectedColor !== value) {
            this.changeDetectorRef.markForCheck();
        }
        const color = parseColorString(value);
        if (color) {
            this._selectedColor = formatColor(color, this.format);
        }
        else {
            this._selectedColor = this.emptyColor;
        }
    }
    /**
     * Define if the panel will be initiated open
     */
    set isOpen(value) {
        this._isOpen = coerceBooleanProperty(value);
        this.changeDetectorRef.detectChanges();
    }
    get isOpen() {
        return this._isOpen;
    }
    /**
     * Define if the panel will show in overlay or not
     */
    set overlay(value) {
        this._overlay = coerceBooleanProperty(value);
    }
    get overlay() {
        return this._overlay;
    }
    /**
     * Hide the action buttons (cancel/confirm)
     */
    set hideButtons(value) {
        this._hideButtons = coerceBooleanProperty(value);
    }
    get hideButtons() {
        return this._hideButtons;
    }
    /**
     * Define new height for the selector
     */
    set colorPickerSelectorHeight(height) {
        this._colorPickerSelectorHeight = height;
    }
    get colorPickerSelectorHeight() {
        return this._colorPickerSelectorHeight;
    }
    /**
     * Hide the color picker selector
     */
    set hideColorPickerSelector(value) {
        this._hideColorPickerSelector = coerceBooleanProperty(value);
    }
    get hideColorPickerSelector() {
        return this._hideColorPickerSelector;
    }
    /**
     * Show alpha selector
     */
    set alpha(value) {
        this._alpha = coerceBooleanProperty(value);
    }
    get alpha() {
        return this._alpha;
    }
    /**
     * Return a Observable with the color the user is picking
     */
    get tmpSelectedColor$() {
        return this._tmpSelectedColor.asObservable();
    }
    /**
     * Observable with all the colors used by the user
     */
    get usedColors$() {
        return this.colorPickerService.getUsedColors().pipe(map(colors => colors.map(color => {
            const clr = parseColorString(color);
            if (this._alpha || clr.getAlpha() === 1) {
                return formatColor(clr, this.format);
            }
        })), map(colors => (!this._reverseUsedColor ? colors : [...colors].reverse())));
    }
    ngOnInit() {
        this.colorPickerCollectionService.alpha = this._alpha;
        this.colorPickerCollectionService.format = this.format;
        if (!this._selectedColor) {
            this._selectedColor = this.emptyColor;
        }
        this._tmpSelectedColor = new BehaviorSubject(this._selectedColor);
    }
    /**
     * Walk throw all collections and subcribe to changes
     */
    ngAfterContentInit() {
        if (this._collections) {
            this._collections.forEach((collection) => {
                const subscription = collection.changeColor.subscribe(color => {
                    this.updateTmpSelectedColor(color);
                });
                this._collectionSubs.push(subscription);
            });
        }
        // change selected color on service
        this.selected.subscribe(color => this.colorPickerCollectionService.changeSelectedColor(color));
    }
    /**
     * Destroy all subscriptions
     */
    ngOnDestroy() {
        if (this._collectionSubs) {
            this._collectionSubs.forEach((subscription) => {
                if (subscription && !subscription.closed) {
                    subscription.unsubscribe();
                }
            });
        }
    }
    /**
     * Update selected color and emit the change
     */
    _updateSelectedColor() {
        if (this._isOpen || !this.overlay) {
            const color = this._tmpSelectedColor.getValue();
            if (this._selectedColor !== color) {
                this._selectedColor = color;
                this.selected.emit(color);
            }
            else {
                this.selected.emit(color);
            }
        }
    }
    /**
     * Open/close color picker panel
     */
    toggle() {
        if (!this._disabled) {
            this._isOpen = !this._isOpen;
            if (this._selectedColor !== this.emptyColor) {
                this.colorPickerService.addColor(this._selectedColor);
            }
            this.colorPickerCollectionService.changeSelectedColor(this._selectedColor);
        }
    }
    /**
     * Update selected color, close the panel and notify the user
     */
    backdropClick() {
        if (this._hideButtons) {
            this.confirmSelectedColor();
        }
        else {
            this.cancelSelection();
        }
        this.clickOut.emit();
        this.changeDetectorRef.detectChanges();
    }
    /**
     * Update tmpSelectedColor
     * @param color string
     */
    updateTmpSelectedColor(color) {
        const clr = parseColorString(color);
        const clrString = color === this.emptyColor ? color : formatColor(clr, this.format);
        this._tmpSelectedColor.next(clrString);
        if (this._selectedColor !== clrString) {
            this.change.emit(clrString);
            if (this._hideButtons) {
                this._updateSelectedColor();
            }
        }
    }
    /**
     * Cancel the selection and close the panel
     */
    cancelSelection() {
        this._tmpSelectedColor.next(this._selectedColor);
        this.colorPickerCollectionService.changeSelectedColor(this.selectedColor);
        this.canceled.emit();
        this.toggle();
    }
    /**
     * Update selectedColor and close the panel
     */
    confirmSelectedColor() {
        this._updateSelectedColor();
        this.toggle();
    }
}
MccColorPickerComponent.ɵfac = function MccColorPickerComponent_Factory(t) { return new (t || MccColorPickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(MccColorPickerService), ɵngcc0.ɵɵdirectiveInject(MccColorPickerCollectionService), ɵngcc0.ɵɵdirectiveInject(EMPTY_COLOR), ɵngcc0.ɵɵdirectiveInject(ENABLE_ALPHA_SELECTOR), ɵngcc0.ɵɵdirectiveInject(COLOR_STRING_FORMAT)); };
MccColorPickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MccColorPickerComponent, selectors: [["mcc-color-picker"]], contentQueries: function MccColorPickerComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MccColorPickerCollectionComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._collections = _t);
    } }, inputs: { usedSizeColors: "usedSizeColors", btnCancelLabel: "btnCancelLabel", btnConfirmLabel: "btnConfirmLabel", format: "format", disabled: "disabled", usedColorLabel: "usedColorLabel", usedColorStart: "usedColorStart", reverseUsedColors: "reverseUsedColors", usedColorsPosition: "usedColorsPosition", hideHexForms: "hideHexForms", hideEmpty: ["hideEmptyUsedColors", "hideEmpty"], hideTransparent: ["hideTransparentUsedColors", "hideTransparent"], hideUsedColors: "hideUsedColors", selectedColor: "selectedColor", isOpen: "isOpen", overlay: "overlay", hideButtons: "hideButtons", colorPickerSelectorHeight: "colorPickerSelectorHeight", hideColorPickerSelector: "hideColorPickerSelector", alpha: "alpha" }, outputs: { change: "change", selected: "selected", clickOut: "clickOut", canceled: "canceled" }, features: [ɵngcc0.ɵɵProvidersFeature([MccColorPickerCollectionService])], ngContentSelectors: _c2, decls: 4, vars: 2, consts: [[4, "ngIf"], ["cdkPortal", ""], ["overlayPanel", "cdkPortal"], ["type", "button", "cdkOverlayOrigin", "", 1, "btn-picker", 3, "ngClass", "click"], ["triggerButton", "cdkOverlayOrigin"], [1, "btn-picker-background"], ["cdkConnectedOverlay", "", "cdkConnectedOverlayHasBackdrop", "", "cdkConnectedOverlayBackdropClass", "mcc-color-picker-backdrop", "cdkConnectedOverlayPush", "", 3, "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "backdropClick"], [3, "cdkPortalOutlet"], ["role", "dialog", "aria-label", "Color picker", 1, "mcc-color-picker-overlay", "mat-elevation-z4", 3, "ngClass"], [3, "selectedColor", "hideHexForms", "height", "changeSelectedColor", 4, "ngIf"], ["class", "mcc-color-picker-actions", 4, "ngIf"], [3, "selectedColor", "hideHexForms", "height", "changeSelectedColor"], [3, "label", "size", "transparent", "hideEmpty", "colors", "changeColor"], [1, "mcc-color-picker-actions"], [2, "flex", "1 auto"], ["mat-button", "", "role", "button", "aria-label", "Cancel", 3, "click"], ["mat-button", "", "role", "button", "aria-label", "Confirm", 3, "click"]], template: function MccColorPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, MccColorPickerComponent_ng_container_0_Template, 5, 8, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, MccColorPickerComponent_1_Template, 1, 1, null, 0);
        ɵngcc0.ɵɵtemplate(2, MccColorPickerComponent_ng_template_2_Template, 6, 7, "ng-template", 1, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.overlay);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.overlay);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc3.CdkPortal, ɵngcc3.CdkPortalOutlet, ɵngcc4.CdkConnectedOverlay, ɵngcc4.CdkOverlayOrigin, ɵngcc2.MatButton, MccColorPickerSelectorComponent, MccColorPickerCollectionComponent, ɵngcc1.AsyncPipe]; }, styles: [".btn-picker[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2 2\"><path d=\"M1 2V0h1v1H0v1z\" fill-opacity=\"0.1\"/></svg>');background-repeat:repeat;background-size:14px;border:2px solid #ddd;border-radius:3px;cursor:pointer;height:25px;position:relative;width:25px}.btn-picker[_ngcontent-%COMP%]   .btn-picker-background[_ngcontent-%COMP%]{bottom:0;left:0;position:absolute;right:0;top:0}.btn-picker.empty[_ngcontent-%COMP%]{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfAQMAAAAlYIR6AAAABlBMVEX/////EBC8L+WmAAAAJ0lEQVR42mM4wAAED0DEBxBRASJsQIQciOAHEewNQIIZpJCRjgr5AP7LD2UBZrkqAAAAAElFTkSuQmCC\")!important;background-repeat:no-repeat;background-size:auto}.btn-picker.disabled[_ngcontent-%COMP%]{opacity:.5}.mcc-color-picker-overlay[_ngcontent-%COMP%]{background:#fff;border-radius:4px;display:flex;flex-direction:column;font-family:Roboto,sans-serif;min-height:80px;padding:0;position:relative;width:270px}.mcc-color-picker-overlay.alpha-enabled[_ngcontent-%COMP%]{width:316px}.mcc-color-picker-overlay[_ngcontent-%COMP%]   .mcc-color-picker-preview[_ngcontent-%COMP%]{height:8px;width:100%}.transparent[_ngcontent-%COMP%]{-webkit-transform:translateY(-2px) translateX(-11px) rotate(45deg);border-bottom:2px solid red;display:block;height:2px;position:absolute;transform:translateY(-3px) translateX(-2px) rotate(45deg);width:32px}.mcc-color-picker-actions[_ngcontent-%COMP%]{border-top:1px solid #ddd;display:flex;padding:4px}.mcc-color-picker-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{text-transform:uppercase}  mat-form-field mcc-color-picker .btn-picker{margin-left:4px;margin-right:4px}"], changeDetection: 0 });
MccColorPickerComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef },
    { type: MccColorPickerService },
    { type: MccColorPickerCollectionService },
    { type: String, decorators: [{ type: Inject, args: [EMPTY_COLOR,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [ENABLE_ALPHA_SELECTOR,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [COLOR_STRING_FORMAT,] }] }
];
MccColorPickerComponent.propDecorators = {
    _collections: [{ type: ContentChildren, args: [MccColorPickerCollectionComponent,] }],
    disabled: [{ type: Input }],
    usedColorLabel: [{ type: Input }],
    usedColorStart: [{ type: Input }],
    reverseUsedColors: [{ type: Input }],
    usedColorsPosition: [{ type: Input }],
    hideHexForms: [{ type: Input }],
    hideEmpty: [{ type: Input, args: ['hideEmptyUsedColors',] }],
    hideTransparent: [{ type: Input, args: ['hideTransparentUsedColors',] }],
    hideUsedColors: [{ type: Input, args: ['hideUsedColors',] }],
    selectedColor: [{ type: Input }],
    isOpen: [{ type: Input }],
    overlay: [{ type: Input }],
    hideButtons: [{ type: Input }],
    colorPickerSelectorHeight: [{ type: Input }],
    hideColorPickerSelector: [{ type: Input }],
    usedSizeColors: [{ type: Input }],
    btnCancelLabel: [{ type: Input }],
    btnConfirmLabel: [{ type: Input }],
    alpha: [{ type: Input }],
    format: [{ type: Input }],
    change: [{ type: Output }],
    selected: [{ type: Output }],
    clickOut: [{ type: Output }],
    canceled: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MccColorPickerComponent, [{
        type: Component,
        args: [{ selector: 'mcc-color-picker', template: "<!-- color picker overlay -->\n<ng-container *ngIf=\"overlay\">\n  <button\n    type=\"button\"\n    class=\"btn-picker\"\n    cdkOverlayOrigin\n    #triggerButton=\"cdkOverlayOrigin\"\n    (click)=\"toggle()\"\n    [ngClass]=\"{ empty: selectedColor === emptyColor, disabled: disabled }\"\n  >\n    <span class=\"btn-picker-background\" [style.backgroundColor]=\"selectedColor\"></span>\n  </button>\n\n<!--  TODO: try to center with the overlay centerHorizontally on mobile instead of cdkConnectedOverlayPush-->\n  <ng-template\n    cdkConnectedOverlay\n    cdkConnectedOverlayHasBackdrop\n    cdkConnectedOverlayBackdropClass=\"mcc-color-picker-backdrop\"\n    cdkConnectedOverlayPush\n    [cdkConnectedOverlayOrigin]=\"triggerButton\"\n    [cdkConnectedOverlayOpen]=\"isOpen\"\n    (backdropClick)=\"backdropClick()\"\n  >\n    <ng-template [cdkPortalOutlet]=\"overlayPanel\"></ng-template>\n  </ng-template>\n</ng-container>\n\n<!-- color picker flat -->\n<ng-template *ngIf=\"!overlay\" [cdkPortalOutlet]=\"overlayPanel\"></ng-template>\n\n<!-- color picker component content -->\n<ng-template cdkPortal #overlayPanel=\"cdkPortal\">\n  <div class=\"mcc-color-picker-overlay mat-elevation-z4\" [ngClass]=\"{ 'alpha-enabled': alpha }\" role=\"dialog\" aria-label=\"Color picker\">\n    <mcc-color-picker-selector\n      *ngIf=\"!hideColorPickerSelector\"\n      [selectedColor]=\"tmpSelectedColor$ | async\"\n      [hideHexForms]=\"hideHexForms\"\n      [height]=\"colorPickerSelectorHeight\"\n      (changeSelectedColor)=\"updateTmpSelectedColor($event)\"\n    >\n    </mcc-color-picker-selector>\n\n    <!-- show used colors on top -->\n    <ng-container *ngIf=\"!hideUsedColors && usedColorsPosition == 'top'\">\n      <mcc-color-picker-collection\n        [label]=\"usedColorLabel\"\n        [size]=\"usedSizeColors\"\n        [transparent]=\"!hideTransparent\"\n        [hideEmpty]=\"hideEmpty\"\n        [colors]=\"usedColors$ | async\"\n        (changeColor)=\"updateTmpSelectedColor($event)\"\n      >\n      </mcc-color-picker-collection>\n    </ng-container>\n\n    <!-- render user collections -->\n    <ng-content></ng-content>\n\n    <!-- show used colors on bottom -->\n    <ng-container *ngIf=\"!hideUsedColors && usedColorsPosition == 'bottom'\">\n      <mcc-color-picker-collection\n        [label]=\"usedColorLabel\"\n        [size]=\"usedSizeColors\"\n        [transparent]=\"!hideTransparent\"\n        [hideEmpty]=\"hideEmpty\"\n        [colors]=\"usedColors$ | async\"\n        (changeColor)=\"updateTmpSelectedColor($event)\"\n      >\n      </mcc-color-picker-collection>\n    </ng-container>\n\n    <div *ngIf=\"!hideButtons\" class=\"mcc-color-picker-actions\">\n      <div style=\"flex: 1 auto;\"></div>\n      <button mat-button role=\"button\" aria-label=\"Cancel\" (click)=\"cancelSelection()\">\n        {{ btnCancelLabel }}\n      </button>\n\n      <button mat-button role=\"button\" aria-label=\"Confirm\" (click)=\"confirmSelectedColor()\">\n        {{ btnConfirmLabel }}\n      </button>\n    </div>\n  </div>\n</ng-template>\n", preserveWhitespaces: false, changeDetection: ChangeDetectionStrategy.OnPush, providers: [MccColorPickerCollectionService], styles: [".btn-picker{background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2 2\"><path d=\"M1 2V0h1v1H0v1z\" fill-opacity=\"0.1\"/></svg>');background-repeat:repeat;background-size:14px;border:2px solid #ddd;border-radius:3px;cursor:pointer;height:25px;position:relative;width:25px}.btn-picker .btn-picker-background{bottom:0;left:0;position:absolute;right:0;top:0}.btn-picker.empty{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfAQMAAAAlYIR6AAAABlBMVEX/////EBC8L+WmAAAAJ0lEQVR42mM4wAAED0DEBxBRASJsQIQciOAHEewNQIIZpJCRjgr5AP7LD2UBZrkqAAAAAElFTkSuQmCC\")!important;background-repeat:no-repeat;background-size:auto}.btn-picker.disabled{opacity:.5}.mcc-color-picker-overlay{background:#fff;border-radius:4px;display:flex;flex-direction:column;font-family:Roboto,sans-serif;min-height:80px;padding:0;position:relative;width:270px}.mcc-color-picker-overlay.alpha-enabled{width:316px}.mcc-color-picker-overlay .mcc-color-picker-preview{height:8px;width:100%}.transparent{-webkit-transform:translateY(-2px) translateX(-11px) rotate(45deg);border-bottom:2px solid red;display:block;height:2px;position:absolute;transform:translateY(-3px) translateX(-2px) rotate(45deg);width:32px}.mcc-color-picker-actions{border-top:1px solid #ddd;display:flex;padding:4px}.mcc-color-picker-actions button{text-transform:uppercase}::ng-deep mat-form-field mcc-color-picker .btn-picker{margin-left:4px;margin-right:4px}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: MccColorPickerService }, { type: MccColorPickerCollectionService }, { type: String, decorators: [{
                type: Inject,
                args: [EMPTY_COLOR]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [ENABLE_ALPHA_SELECTOR]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [COLOR_STRING_FORMAT]
            }] }]; }, { usedSizeColors: [{
            type: Input
        }], btnCancelLabel: [{
            type: Input
        }], btnConfirmLabel: [{
            type: Input
        }], change: [{
            type: Output
        }], selected: [{
            type: Output
        }], clickOut: [{
            type: Output
        }], canceled: [{
            type: Output
        }], format: [{
            type: Input
        }], disabled: [{
            type: Input
        }], usedColorLabel: [{
            type: Input
        }], usedColorStart: [{
            type: Input
        }], reverseUsedColors: [{
            type: Input
        }], usedColorsPosition: [{
            type: Input
        }], hideHexForms: [{
            type: Input
        }], hideEmpty: [{
            type: Input,
            args: ['hideEmptyUsedColors']
        }], hideTransparent: [{
            type: Input,
            args: ['hideTransparentUsedColors']
        }], hideUsedColors: [{
            type: Input,
            args: ['hideUsedColors']
        }], selectedColor: [{
            type: Input
        }], isOpen: [{
            type: Input
        }], overlay: [{
            type: Input
        }], hideButtons: [{
            type: Input
        }], colorPickerSelectorHeight: [{
            type: Input
        }], hideColorPickerSelector: [{
            type: Input
        }], alpha: [{
            type: Input
        }], _collections: [{
            type: ContentChildren,
            args: [MccColorPickerCollectionComponent]
        }] }); })();

/**
 * Directive connect an color picker with any input, select or textarea.
 * The color picker will be automatically updated when the value of the origin is
 * changed.
 */
class MccConnectedColorPickerDirective {
    constructor(colorPicker, changeDetectorRef, emptyColor) {
        this.colorPicker = colorPicker;
        this.changeDetectorRef = changeDetectorRef;
        this.emptyColor = emptyColor;
    }
    ngAfterViewInit() {
        if (!this._colorPickerSub) {
            this._attachColorPicker();
        }
    }
    ngOnDestroy() {
        if (this._colorPickerSub && !this._colorPickerSub.closed) {
            this._colorPickerSub.unsubscribe();
        }
        if (this._originSub && !this._originSub.closed) {
            this._originSub.unsubscribe();
        }
        if (this._focusSub && !this._focusSub.closed) {
            this._focusSub.unsubscribe();
        }
    }
    /**
     * Attach color picker and origin
     */
    _attachColorPicker() {
        // subscribe to origin change to update color picker
        this._originSub = this.origin.change.subscribe(value => {
            const color = parseColorString(value);
            if (value === this.emptyColor && this.colorPicker.selectedColor !== this.emptyColor) {
                this.colorPicker.updateTmpSelectedColor(value);
            }
            else if (color) {
                this.colorPicker.updateTmpSelectedColor(value);
                this.colorPicker.selectedColor = value;
                this.changeDetectorRef.detectChanges();
            }
        });
        this._focusSub = this.origin.hasFocus.subscribe(() => {
            this.colorPicker.isOpen = true;
        });
        // subscribe to color picker confirmation and set on origin element
        // TODO: changed to on confirm. maybe support on-change mode again?
        this._colorPickerSub = this.colorPicker.selected.subscribe(value => this.origin.writeValueFromColorPicker(value));
    }
}
MccConnectedColorPickerDirective.ɵfac = function MccConnectedColorPickerDirective_Factory(t) { return new (t || MccConnectedColorPickerDirective)(ɵngcc0.ɵɵdirectiveInject(MccColorPickerComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(EMPTY_COLOR)); };
MccConnectedColorPickerDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MccConnectedColorPickerDirective, selectors: [["", "mcc-connected-color-picker", ""], ["", "mccConnectedColorPicker", ""]], inputs: { origin: ["mccConnectedColorPickerOrigin", "origin"] }, exportAs: ["mccConnectedColorPicker"] });
MccConnectedColorPickerDirective.ctorParameters = () => [
    { type: MccColorPickerComponent },
    { type: ChangeDetectorRef },
    { type: String, decorators: [{ type: Inject, args: [EMPTY_COLOR,] }] }
];
MccConnectedColorPickerDirective.propDecorators = {
    origin: [{ type: Input, args: ['mccConnectedColorPickerOrigin',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MccConnectedColorPickerDirective, [{
        type: Directive,
        args: [{
                selector: '[mcc-connected-color-picker], [mccConnectedColorPicker]',
                exportAs: 'mccConnectedColorPicker'
            }]
    }], function () { return [{ type: MccColorPickerComponent }, { type: ɵngcc0.ChangeDetectorRef }, { type: String, decorators: [{
                type: Inject,
                args: [EMPTY_COLOR]
            }] }]; }, { origin: [{
            type: Input,
            args: ['mccConnectedColorPickerOrigin']
        }] }); })();

const INITIAL_COLOR = new TinyColor('white');
class MccColorPickerSelectorComponent {
    constructor(formBuilder, renderer, colorPickerCollectionService, emptyColor) {
        this.formBuilder = formBuilder;
        this.renderer = renderer;
        this.colorPickerCollectionService = colorPickerCollectionService;
        this.emptyColor = emptyColor;
        this._height = 170;
        this._selectedColor = INITIAL_COLOR;
        this._hideHexForms = false;
        /**
         * Emit update when a color is selected
         */
        this.changeSelectedColor = new EventEmitter();
        /**
         * Subject of the current selected color by the user
         */
        this._tmpSelectedColor = new BehaviorSubject(this._selectedColor);
        /**
         * Handle color of the form inputs text
         */
        this.textClass = 'black';
        /**
         * Keeps track if the mouse button is pressed
         */
        this._isPressed = false;
        /**
         * keeping mousedown listeners for destruction
         */
        this._mouseDownListeners = [];
        /**
         * keeping track of temporary mouse listeners for destruction
         */
        this._temporaryMouseListeners = [];
        this._selectorWidth = 240;
        this._stripWidth = 20;
    }
    /**
     * Container of the strip
     */
    set hueContainer(el) {
        this._sc = el;
    }
    /**
     * Change height base of the selector
     */
    set height(value) {
        this._height = value;
    }
    get height() {
        return this._height;
    }
    get stripHeight() {
        return this._height - 10;
    }
    /**
     * Receive selected color from the component
     */
    set selectedColor(value) {
        if (value === this.emptyColor) {
            this.noColor = true;
            // use "EMPTY_COLOR" as real color if it can be parsed as such
            this._selectedColor = parseColorString(this.emptyColor) || INITIAL_COLOR;
        }
        else {
            const color = parseColorString(value);
            if (color) {
                this._selectedColor = color.setAlpha(color['_roundA']);
                this.noColor = false;
            }
        }
    }
    /**
     * Hide the hexadecimal color forms.
     */
    set hideHexForms(value) {
        this._hideHexForms = value;
    }
    get hideHexForms() {
        return this._hideHexForms;
    }
    get selectorWidth() {
        return this._selectorWidth;
    }
    get stripWidth() {
        return this._stripWidth;
    }
    get tmpSelectedColorAsRgba$() {
        return this._tmpSelectedColor.asObservable().pipe(map(toRgb), distinctUntilChanged());
    }
    ngOnInit() {
        // set initial position for selection block
        this._latestBlockCoordinates = { x: this._selectorWidth - 1, y: Math.floor(this._height / 2) };
        // set selectedColor initial value
        this._tmpSelectedColor.next(this._selectedColor);
        this._tmpSelectedColorSub = this._tmpSelectedColor.subscribe(color => {
            this.textClass = color.isDark() && color.getAlpha() > 0.3 ? 'white' : 'black';
            // right now using hex for non alpha and rgba for alpha colors
            if (this.noColor) {
                this.changeSelectedColor.emit(this.emptyColor);
                this.colorPickerCollectionService.changeSelectedColor(this.emptyColor);
            }
            else {
                const clr = formatColor(color, this.colorPickerCollectionService.format);
                this.changeSelectedColor.emit(clr);
                this.colorPickerCollectionService.changeSelectedColor(clr);
            }
        });
        // hex form
        this.hexForm = this.formBuilder.group({
            hexCode: new FormControl(toHex(this._selectedColor), {
                validators: [Validators.pattern(/^#([0-9A-F]{8}|[0-9A-F]{6})$/gi)],
                updateOn: 'change'
            })
        });
        // rgb form
        const rgbKeys = ['R', 'G', 'B'];
        const rgbaGroup = {};
        const rgb = this._selectedColor.toRgb();
        const rgbValues = [rgb.r, rgb.g, rgb.b, rgb.a];
        rgbKeys.forEach((key, index) => (rgbaGroup[key] = new FormControl(rgbValues[index], {
            validators: [Validators.min(0), Validators.max(255), Validators.required],
            updateOn: 'change'
        })));
        // add alpha input to rgb form
        rgbaGroup['A'] = new FormControl(this._selectedColor.getAlpha(), {
            validators: [Validators.min(0), Validators.max(1), Validators.required]
        });
        this.rgbaForm = this.formBuilder.group(rgbaGroup);
        this._watchFormChanges();
    }
    /**
     * Update forms and selectors selectedColor change and
     * the mouse button is not pressed
     */
    ngOnChanges(changes) {
        if ('selectedColor' in changes) {
            if (!this._isPressed) {
                const color = this._selectedColor;
                this._updateHexForm(color);
                this._updateRGBAForm(color);
                this.setSelectorPositions(color);
                this._drawBlockSelector(color);
                if (this.colorPickerCollectionService.alpha) {
                    this._drawAlphaSelector(color);
                }
                this._tmpSelectedColor.next(color);
            }
        }
    }
    ngOnDestroy() {
        // destroy listeners
        this._mouseDownListeners.forEach(listener => listener());
        this._temporaryMouseListeners.forEach(listener => listener());
        // unsubscribe
        if (this._tmpSelectedColorSub && !this._tmpSelectedColorSub.closed) {
            this._tmpSelectedColorSub.unsubscribe();
        }
        if (this._hexValuesSub && !this._hexValuesSub.closed) {
            this._hexValuesSub.unsubscribe();
        }
        if (this._rgbValuesSub && !this._rgbValuesSub.closed) {
            this._rgbValuesSub.unsubscribe();
        }
    }
    ngAfterViewInit() {
        // draw initial selectors and listen to mouse events
        this._mouseDownListeners.push(this.renderer.listen(this._block.nativeElement, 'touchstart', (e) => {
            if (e.cancelable) {
                e.preventDefault();
                this._isPressed = true;
                this._selectionTargetPosition = this._block.nativeElement.getBoundingClientRect();
                this._listenToMouseForBlock();
                const x = e.targetTouches[0].clientX - this._selectionTargetPosition.x;
                const y = e.targetTouches[0].clientY - this._selectionTargetPosition.y;
                this.changeColor({ x: x, y: y });
            }
        }));
        this._mouseDownListeners.push(this.renderer.listen(this._block.nativeElement, 'mousedown', (e) => {
            e.preventDefault();
            this._isPressed = true;
            this._selectionTargetPosition = this._block.nativeElement.getBoundingClientRect();
            this._listenToMouseForBlock();
            this.changeColor({ x: e.offsetX, y: e.offsetY });
        }));
        this._blockContext = this._bc.nativeElement.getContext('2d');
        this._blockContext.rect(0, 0, this._bc.nativeElement.width, this._bc.nativeElement.height);
        this._mouseDownListeners.push(this.renderer.listen(this._hueSelector.nativeElement, 'touchstart', (e) => {
            if (e.cancelable) {
                e.preventDefault();
                this._isPressed = true;
                this._selectionTargetPosition = this._hueSelector.nativeElement.getBoundingClientRect();
                this._listenToMouseForHue();
                const y = e.targetTouches[0].clientY - this._selectionTargetPosition.y;
                this.changeHue(y);
            }
        }));
        this._mouseDownListeners.push(this.renderer.listen(this._hueSelector.nativeElement, 'mousedown', (e) => {
            e.preventDefault();
            this._isPressed = true;
            this._selectionTargetPosition = this._hueSelector.nativeElement.getBoundingClientRect();
            this._listenToMouseForHue();
            this.changeHue(e.offsetY);
        }));
        if (this.colorPickerCollectionService.alpha) {
            this._drawAlphaSelector(this._selectedColor);
            this._mouseDownListeners.push(this.renderer.listen(this._alpha.nativeElement, 'touchstart', (e) => {
                if (e.cancelable) {
                    e.preventDefault();
                    this._isPressed = true;
                    this._selectionTargetPosition = this._alpha.nativeElement.getBoundingClientRect();
                    this._listenToMouseForAlpha();
                    const y = e.targetTouches[0].clientY - this._selectionTargetPosition.y;
                    this.changeAlpha(y);
                }
            }));
            this._mouseDownListeners.push(this.renderer.listen(this._alpha.nativeElement, 'mousedown', (e) => {
                e.preventDefault();
                this._isPressed = true;
                this._selectionTargetPosition = this._alpha.nativeElement.getBoundingClientRect();
                this._listenToMouseForAlpha();
                this.changeAlpha(e.offsetY);
            }));
            this._alphaContext = this._alpha.nativeElement.getContext('2d');
        }
        this._drawHueSelector();
        this._drawBlockSelector(this._selectedColor);
        if (this.colorPickerCollectionService.alpha) {
            this._drawAlphaSelector(this._selectedColor);
        }
        this.setSelectorPositions(this._selectedColor);
    }
    _listenToMouseForBlock() {
        this._preventTextSelection();
        this._temporaryMouseListeners.push(this.renderer.listen(this._block.nativeElement, 'touchmove', (e) => {
            if (e.cancelable) {
                e.preventDefault();
                const coords = this._getCoordinatesForPosition(e.targetTouches[0].clientX, e.targetTouches[0].clientY);
                this.changeColor(coords);
            }
        }));
        this._temporaryMouseListeners.push(this.renderer.listen(this._block.nativeElement, 'mousemove', (e) => {
            if (e.buttons === 1) {
                this.changeColor({ x: e.offsetX, y: e.offsetY });
            }
        }));
        this._registerMouseUpListeners();
        this._temporaryMouseListeners.push(this.renderer.listen(document, 'mousemove', (e) => {
            if (this._isPressed && e.target !== this._block.nativeElement) {
                const coords = this._getCoordinatesForPosition(e.clientX, e.clientY);
                this.changeColor(coords);
            }
        }));
    }
    _listenToMouseForHue() {
        this._preventTextSelection();
        this._temporaryMouseListeners.push(this.renderer.listen(this._hueSelector.nativeElement, 'touchmove', (e) => {
            if (e.cancelable) {
                e.preventDefault();
                const y = this._getYForPosition(e.targetTouches[0].clientY);
                this.changeHue(y);
            }
        }));
        this._temporaryMouseListeners.push(this.renderer.listen(this._hueSelector.nativeElement, 'mousemove', (e) => {
            if (e.buttons === 1) {
                this.changeHue(e.offsetY);
            }
        }));
        this._registerMouseUpListeners();
        this._temporaryMouseListeners.push(this.renderer.listen(document, 'mousemove', (e) => {
            if (this._isPressed && e.target !== this._hueSelector.nativeElement) {
                const y = this._getYForPosition(e.clientY);
                this.changeHue(y);
            }
        }));
    }
    _listenToMouseForAlpha() {
        this._preventTextSelection();
        this._temporaryMouseListeners.push(this.renderer.listen(this._alpha.nativeElement, 'touchmove', (e) => {
            if (e.cancelable) {
                e.preventDefault();
                const y = this._getYForPosition(e.targetTouches[0].clientY);
                this.changeAlpha(y);
            }
        }));
        this._temporaryMouseListeners.push(this.renderer.listen(this._alpha.nativeElement, 'mousemove', (e) => {
            if (e.buttons === 1) {
                this.changeAlpha(e.offsetY);
            }
        }));
        this._registerMouseUpListeners();
        this._temporaryMouseListeners.push(this.renderer.listen(document, 'mousemove', (e) => {
            if (this._isPressed && e.target !== this._alpha.nativeElement) {
                const y = this._getYForPosition(e.clientY);
                this.changeAlpha(y);
            }
        }));
    }
    _preventTextSelection() {
        this._temporaryMouseListeners.push(this.renderer.listen(document, 'selectstart', (e) => {
            e.preventDefault();
        }));
    }
    _registerMouseUpListeners() {
        this._temporaryMouseListeners.push(this.renderer.listen(document, 'touchend', (e) => {
            if (e.cancelable) {
                e.preventDefault();
                this._isPressed = false;
                this._temporaryMouseListeners.forEach(listener => listener());
            }
        }));
        this._temporaryMouseListeners.push(this.renderer.listen(document, 'mouseup', (e) => {
            e.preventDefault();
            this._isPressed = false;
            this._temporaryMouseListeners.forEach(listener => listener());
        }));
    }
    _getCoordinatesForPosition(clientX, clientY) {
        let x;
        if (clientX < this._selectionTargetPosition.left) {
            x = 0;
        }
        else if (clientX > this._selectionTargetPosition.right) {
            x = this._selectionTargetPosition.width;
        }
        else {
            x = clientX - this._selectionTargetPosition.left;
        }
        let y;
        if (clientY < this._selectionTargetPosition.top) {
            y = 0;
        }
        else if (clientY > this._selectionTargetPosition.bottom) {
            y = this._selectionTargetPosition.height;
        }
        else {
            y = clientY - this._selectionTargetPosition.top;
        }
        return { x, y };
    }
    _getYForPosition(clientY) {
        let y;
        if (clientY < this._selectionTargetPosition.top) {
            y = 0;
        }
        else if (clientY > this._selectionTargetPosition.bottom) {
            y = this._selectionTargetPosition.height;
        }
        else {
            y = clientY - this._selectionTargetPosition.top;
        }
        return y;
    }
    _drawHueSelector() {
        this._hueSelectorContext = this._hueSelector.nativeElement.getContext('2d');
        this._hueSelectorContext.rect(0, 0, this._hueSelector.nativeElement.width, this._hueSelector.nativeElement.height);
        const grd1 = this._hueSelectorContext.createLinearGradient(0, 0, 0, this._bc.nativeElement.height);
        grd1.addColorStop(0, 'hsl(0, 100%, 50%)');
        grd1.addColorStop(0.125, 'hsl(45, 100%, 50%)');
        grd1.addColorStop(0.25, 'hsl(90, 100%, 50%)');
        grd1.addColorStop(0.375, 'hsl(135, 100%, 50%)');
        grd1.addColorStop(0.5, 'hsl(180, 100%, 50%)');
        grd1.addColorStop(0.625, 'hsl(225, 100%, 50%)');
        grd1.addColorStop(0.75, 'hsl(270, 100%, 50%)');
        grd1.addColorStop(0.875, 'hsl(315, 100%, 50%)');
        grd1.addColorStop(1, 'hsl(360, 100%, 50%)');
        this._hueSelectorContext.fillStyle = grd1;
        this._hueSelectorContext.fill();
    }
    /**
     * Generate alpha selector gradient based on the RGB color
     */
    _drawAlphaSelector(color) {
        if (this._alphaContext) {
            this._alphaContext.clearRect(0, 0, this._alpha.nativeElement.width, this._alpha.nativeElement.height);
            const alphaGrd2 = this._alphaContext.createLinearGradient(0, 0, 0, this._bc.nativeElement.height);
            alphaGrd2.addColorStop(0, `rgba(${color.toRgb().r}, ${color.toRgb().g}, ${color.toRgb().b}, 1)`);
            alphaGrd2.addColorStop(1, `rgba(${color.toRgb().r}, ${color.toRgb().g}, ${color.toRgb().b}, 0)`);
            this._alphaContext.fillStyle = alphaGrd2;
            this._alphaContext.fillRect(0, 0, this._alpha.nativeElement.width, this._alpha.nativeElement.height);
        }
    }
    /**
     * Generate color selector block based on the RGB color
     */
    _drawBlockSelector(hueColor) {
        if (this._blockContext) {
            this._blockContext.fillStyle = `hsl(${hueColor.toHsl().h}, 100%, 50%)`;
            this._blockContext.fillRect(0, 0, this._bc.nativeElement.width, this._bc.nativeElement.height);
            // HSL selector
            const grdWhite = this._hueSelectorContext.createLinearGradient(1, 0, this._bc.nativeElement.width - 1, 0);
            grdWhite.addColorStop(0, 'rgba(255,255,255,1)');
            grdWhite.addColorStop(1, 'rgba(255,255,255,0)');
            this._blockContext.fillStyle = grdWhite;
            this._blockContext.fillRect(0, 0, this._bc.nativeElement.width, this._bc.nativeElement.height);
            const grdBlack = this._hueSelectorContext.createLinearGradient(0, 1, 0, this._bc.nativeElement.height - 1);
            grdBlack.addColorStop(0, 'rgba(0,0,0,0)');
            grdBlack.addColorStop(1, 'rgba(0,0,0,1)');
            this._blockContext.fillStyle = grdBlack;
            this._blockContext.fillRect(0, 0, this._bc.nativeElement.width, this._bc.nativeElement.height);
        }
    }
    /**
     * Watch changes on forms
     */
    _watchFormChanges() {
        this._hexValuesSub = this.hexForm.valueChanges.subscribe(value => {
            if (this.hexForm.valid) {
                const color = new TinyColor(value.hexCode);
                this._updateRGBAForm(color);
                this._drawBlockSelector(color);
                if (this.colorPickerCollectionService.alpha) {
                    this._drawAlphaSelector(color);
                }
                this.setSelectorPositions(color);
                this._tmpSelectedColor.next(color);
            }
        });
        this._rgbValuesSub = this.rgbaForm.valueChanges.subscribe(rgba => {
            if (this.rgbaForm.valid) {
                const color = new TinyColor({ r: rgba.R, g: rgba.G, b: rgba.B, a: rgba.A });
                this._updateHexForm(color);
                this._drawBlockSelector(color);
                if (this.colorPickerCollectionService.alpha) {
                    this._drawAlphaSelector(color);
                }
                this.setSelectorPositions(color);
                this._tmpSelectedColor.next(color);
            }
        });
    }
    /**
     * Update RGBA form
     */
    _updateRGBAForm(color) {
        if (!this.rgbaForm) {
            return;
        }
        const values = { R: color.toRgb().r, G: color.toRgb().g, B: color.toRgb().b, A: color.toRgb().a };
        this.rgbaForm.setValue(values, { emitEvent: false });
    }
    /**
     * Update hex form
     */
    _updateHexForm(color) {
        if (!this.hexForm) {
            return;
        }
        const hex = toHex(color);
        const control = this.hexForm.get('hexCode');
        control.setValue(hex, { emitEvent: false, onlySelf: true });
        control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
    }
    /**
     * Handle changes of the hue slider
     */
    changeHue(y) {
        if (y <= this.stripHeight) {
            this.setHueSelector(y);
            const data = this._hueSelectorContext.getImageData(this.stripWidth / 2, y, 1, 1).data;
            const color = new TinyColor({ r: data[0], g: data[1], b: data[2] });
            this._drawBlockSelector(color);
            this.changeColor();
        }
    }
    /**
     * Handle changes of the alpha slider
     */
    changeAlpha(y) {
        if (y <= this.stripHeight) {
            this.setAlphaSelector(y);
            const alpha = Number(((this.stripHeight - y) / this.stripHeight).toFixed(2));
            const color = this._selectedColor.clone().setAlpha(alpha);
            this._updateRGBAForm(color);
            this._updateHexForm(color);
            this._tmpSelectedColor.next(color);
            this.noColor = false;
        }
    }
    /**
     * Handle changes of the selected color in the XY block
     */
    changeColor(offsets) {
        const os = offsets || this._latestBlockCoordinates;
        if (os.x <= this._selectorWidth && os.y <= this._height) {
            this.setXYSelector(os);
            const data = this._blockContext.getImageData(os.x ? os.x - 1 : os.x, os.y ? os.y - 1 : os.y, 1, 1).data;
            const color = new TinyColor({ r: data[0], g: data[1], b: data[2], a: this._selectedColor.getAlpha() });
            this._updateRGBAForm(color);
            this._updateHexForm(color);
            if (this.colorPickerCollectionService.alpha) {
                this._drawAlphaSelector(color);
            }
            this._tmpSelectedColor.next(color);
            this.noColor = false;
        }
    }
    /**
     * Set all selectors positions based on a color
     */
    setSelectorPositions(color) {
        const offset = this.getHueOffsets(color);
        this.setHueSelector(offset);
        const offsets = this.getXYOffsets(color);
        this.setXYSelector(offsets);
        const alphaOffset = this.getAlphaOffset(color);
        this.setAlphaSelector(alphaOffset);
    }
    /**
     * Set block selector positions in view
     */
    setXYSelector(offsets) {
        if (this._bp) {
            this.renderer.setStyle(this._bp.nativeElement, 'transform', `translate(${offsets.x - 6}px, ${offsets.y - 6}px)`);
            this._latestBlockCoordinates = offsets;
        }
    }
    /**
     * Set hue selector positions in view
     */
    setHueSelector(offset) {
        if (this._sc) {
            this.renderer.setStyle(this._sc.nativeElement, 'background-position-y', `${offset}px`);
        }
    }
    /**
     * Set alpha selector positions in view
     */
    setAlphaSelector(offset) {
        if (this._ac) {
            this.renderer.setStyle(this._ac.nativeElement, 'background-position-y', `${offset}px`);
        }
    }
    /**
     * Get the X and Y coordinates for the block selector relative to it's size
     */
    getXYOffsets(color) {
        const hsv = color.toHsv();
        const x = this._selectorWidth * hsv.s;
        const y = this._height - this._height * hsv.v;
        return { x, y };
    }
    /**
     * Get the Y coordinate for the hue selector relative to it's height
     */
    getHueOffsets(color) {
        return (this.stripHeight / 360) * color.toHsl().h;
    }
    /**
     * Get the Y coordinate for the alpha selector relative to it's height
     */
    getAlphaOffset(color) {
        return this.stripHeight - this.stripHeight * color.getAlpha();
    }
}
MccColorPickerSelectorComponent.ɵfac = function MccColorPickerSelectorComponent_Factory(t) { return new (t || MccColorPickerSelectorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.FormBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(MccColorPickerCollectionService), ɵngcc0.ɵɵdirectiveInject(EMPTY_COLOR)); };
MccColorPickerSelectorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MccColorPickerSelectorComponent, selectors: [["mcc-color-picker-selector"]], viewQuery: function MccColorPickerSelectorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 5);
        ɵngcc0.ɵɵviewQuery(_c4, 5);
        ɵngcc0.ɵɵviewQuery(_c5, 5);
        ɵngcc0.ɵɵviewQuery(_c6, 5);
        ɵngcc0.ɵɵviewQuery(_c7, 5);
        ɵngcc0.ɵɵviewQuery(_c8, 5);
        ɵngcc0.ɵɵviewQuery(_c9, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.hueContainer = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._block = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._bp = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._bc = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._hueSelector = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._alpha = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._ac = _t.first);
    } }, inputs: { height: "height", selectedColor: "selectedColor", hideHexForms: "hideHexForms" }, outputs: { changeSelectedColor: "changeSelectedColor" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 16, vars: 22, consts: [[1, "mcc-color-picker-selector", 3, "ngStyle"], [1, "mcc-picker-selector"], ["block", ""], ["id", "picker", 3, "height", "width"], ["blockCanvas", ""], [1, "mcc-picker-position", 2, "top", "0", "left", "0"], ["blockPointer", ""], [1, "mcc-colors-position", 2, "background-position-y", "0", 3, "ngClass"], ["hueContainer", ""], ["id", "colors", 3, "height", "width"], ["hueSelector", ""], ["class", "mcc-alpha-position", "style", "background-position-y: 0;", 3, "height", 4, "ngIf"], [1, "mcc-color-picker-selector-preview"], [1, "mcc-color-picker-selector-preview-background"], [4, "ngIf"], [1, "mcc-alpha-position", 2, "background-position-y", "0"], ["alphaContainer", ""], ["id", "alpha", 1, "mcc-alpha-background", 3, "height", "width"], ["alpha", ""], [3, "formGroup"], ["floatLabel", "always", "appearance", "legacy", 1, "hex-input", 3, "ngClass"], ["matInput", "", "placeholder", "HEX", "formControlName", "hexCode"], ["floatLabel", "always", "appearance", "legacy", 1, "rgb-input", 3, "ngClass"], ["matInput", "", "type", "number", "formControlName", "R", 3, "placeholder"], ["matInput", "", "type", "number", "formControlName", "G"], ["matInput", "", "type", "number", "formControlName", "B"], ["class", "rgb-input", "floatLabel", "always", "appearance", "legacy", 3, "ngClass", 4, "ngIf"], ["matInput", "", "type", "number", "formControlName", "A"]], template: function MccColorPickerSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1, 2)(3, "canvas", 3, 4)(5, "div", 5, 6);
        ɵngcc0.ɵɵelementStart(7, "div", 7, 8);
        ɵngcc0.ɵɵelement(9, "canvas", 9, 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, MccColorPickerSelectorComponent_div_11_Template, 4, 4, "div", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 12)(13, "div", 13);
        ɵngcc0.ɵɵpipe(14, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(15, MccColorPickerSelectorComponent_ng_container_15_Template, 12, 8, "ng-container", 14);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(18, _c10, ctx.height));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("height", ctx.height, "px")("width", ctx.selectorWidth, "px");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("height", ctx.height)("width", ctx.selectorWidth);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵstyleProp("height", ctx.height, "px");
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(20, _c1, ctx.colorPickerCollectionService.alpha));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("height", ctx.stripHeight)("width", ctx.stripWidth);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.colorPickerCollectionService.alpha);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("background-color", ɵngcc0.ɵɵpipeBind1(14, 16, ctx.tmpSelectedColorAsRgba$));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideHexForms && !ctx.noColor);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgStyle, ɵngcc5.ɵNgNoValidate, ɵngcc5.DefaultValueAccessor, ɵngcc5.NumberValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgControlStatusGroup, ɵngcc5.FormGroupDirective, ɵngcc5.FormControlName, ɵngcc6.MatFormField, ɵngcc7.MatInput, ɵngcc1.AsyncPipe], styles: ["canvas#alpha[_ngcontent-%COMP%], canvas#colors[_ngcontent-%COMP%]{margin:5px}canvas[_ngcontent-%COMP%]:hover{cursor:crosshair}.mcc-picker-selector[_ngcontent-%COMP%]{cursor:crosshair;left:0;position:absolute;top:0;z-index:10}.mcc-picker-position[_ngcontent-%COMP%]{background:rgba(0,0,0,.3);border:1px solid #ddd;border-radius:50%;height:10px;position:absolute;width:10px;z-index:1}.mcc-colors-position[_ngcontent-%COMP%]{background-image:url(\"data:image/gif;base64,R0lGODdhHgAIALMAAAAAADU1NTk5OUJCQkpKSlZWVltbW2pqaoCAgP///wAAAAAAAAAAAAAAAAAAAAAAACH5BAkAAAoALAAAAAAeAAgAAAQw0BhFq734yjJm/p8xFEVAeGCqGERACmahgkUrvPH81cFdnjoQy8VBBTOiguSokkQAADs=\");background-repeat:no-repeat;position:absolute;right:0;top:0;width:30px;z-index:1}.mcc-colors-position.alpha-enabled[_ngcontent-%COMP%]{right:40px}.mcc-alpha-position[_ngcontent-%COMP%]{background-image:url(\"data:image/gif;base64,R0lGODdhHgAIALMAAAAAADU1NTk5OUJCQkpKSlZWVltbW2pqaoCAgP///wAAAAAAAAAAAAAAAAAAAAAAACH5BAkAAAoALAAAAAAeAAgAAAQw0BhFq734yjJm/p8xFEVAeGCqGERACmahgkUrvPH81cFdnjoQy8VBBTOiguSokkQAADs=\");background-repeat:no-repeat;position:absolute;right:5px;top:0;width:30px;z-index:1}.mcc-alpha-background[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2 2\"><path d=\"M1 2V0h1v1H0v1z\" fill-opacity=\"0.1\"/></svg>');background-repeat:repeat;background-size:14px;bottom:0;left:0;position:absolute;right:0;top:0}.mcc-color-picker-selector[_ngcontent-%COMP%]{height:170px}  mat-form-field{font-size:11px;font-weight:700}  mat-form-field.black,   mat-form-field.black label.mat-form-field-label{color:rgba(0,0,0,.87)!important}  mat-form-field.black .mat-form-field-underline{background-color:rgba(0,0,0,.87)!important}  mat-form-field.white,   mat-form-field.white label.mat-form-field-label{color:#fff!important}  mat-form-field.white .mat-form-field-underline{background-color:#fff!important}.mcc-color-picker-selector-preview[_ngcontent-%COMP%]{background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2 2\"><path d=\"M1 2V0h1v1H0v1z\" fill-opacity=\"0.1\"/></svg>');background-repeat:repeat;background-size:14px;border-bottom:1px solid #e1e1e1;box-sizing:content-box;height:40px;padding:15px;position:relative}.mcc-color-picker-selector-preview[_ngcontent-%COMP%]   .mcc-color-picker-selector-preview-background[_ngcontent-%COMP%]{bottom:0;left:0;position:absolute;right:0;top:0}.mcc-color-picker-selector-preview[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]{display:inline-block;position:relative}.mcc-color-picker-selector-preview[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .mcc-color-picker-selector-preview[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.mcc-color-picker-selector-preview[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]   input[type=number][_ngcontent-%COMP%]{-moz-appearance:textfield}.mcc-color-picker-selector-preview[_ngcontent-%COMP%]   .hex-input[_ngcontent-%COMP%]{margin-right:20px;width:86px}.mcc-color-picker-selector-preview[_ngcontent-%COMP%]   .hex-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{font-size:16px;font-weight:400}.mcc-color-picker-selector-preview[_ngcontent-%COMP%]   .rgb-input[_ngcontent-%COMP%]{margin-right:4px;width:32px}.mcc-color-picker-selector-preview[_ngcontent-%COMP%]   .rgb-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{font-size:16px;font-weight:400}"], changeDetection: 0 });
MccColorPickerSelectorComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: Renderer2 },
    { type: MccColorPickerCollectionService },
    { type: String, decorators: [{ type: Inject, args: [EMPTY_COLOR,] }] }
];
MccColorPickerSelectorComponent.propDecorators = {
    _block: [{ type: ViewChild, args: ['block',] }],
    _bp: [{ type: ViewChild, args: ['blockPointer',] }],
    _bc: [{ type: ViewChild, args: ['blockCanvas',] }],
    _hueSelector: [{ type: ViewChild, args: ['hueSelector',] }],
    hueContainer: [{ type: ViewChild, args: ['hueContainer',] }],
    _alpha: [{ type: ViewChild, args: ['alpha',] }],
    _ac: [{ type: ViewChild, args: ['alphaContainer',] }],
    height: [{ type: Input }],
    selectedColor: [{ type: Input }],
    hideHexForms: [{ type: Input }],
    changeSelectedColor: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MccColorPickerSelectorComponent, [{
        type: Component,
        args: [{ selector: 'mcc-color-picker-selector', template: "<div class=\"mcc-color-picker-selector\" [ngStyle]=\"{ 'height.px': height }\">\n  <div #block class=\"mcc-picker-selector\" [style.height.px]=\"height\" [style.width.px]=\"selectorWidth\"></div>\n  <canvas #blockCanvas [height]=\"height\" [width]=\"selectorWidth\" id=\"picker\"></canvas>\n  <div #blockPointer class=\"mcc-picker-position\" style=\"top: 0; left: 0;\"></div>\n\n  <div\n    #hueContainer\n    class=\"mcc-colors-position\"\n    [style.height.px]=\"height\"\n    [ngClass]=\"{ 'alpha-enabled': colorPickerCollectionService.alpha }\"\n    style=\"background-position-y: 0;\"\n  >\n    <canvas #hueSelector [height]=\"stripHeight\" [width]=\"stripWidth\" id=\"colors\"></canvas>\n  </div>\n\n  <div\n    *ngIf=\"colorPickerCollectionService.alpha\"\n    #alphaContainer\n    class=\"mcc-alpha-position\"\n    [style.height.px]=\"height\"\n    style=\"background-position-y: 0;\"\n  >\n    <canvas #alpha [height]=\"stripHeight\" [width]=\"stripWidth\" id=\"alpha\" class=\"mcc-alpha-background\"></canvas>\n  </div>\n</div>\n\n<div class=\"mcc-color-picker-selector-preview\">\n  <div class=\"mcc-color-picker-selector-preview-background\" [style.backgroundColor]=\"tmpSelectedColorAsRgba$ | async\"></div>\n  <!--  TODO: refactor hex-input and rgb-input classes to be compatible with appearance=\"standard/outline/fill\"-->\n  <ng-container *ngIf=\"!hideHexForms && !noColor\">\n    <form [formGroup]=\"hexForm\">\n      <mat-form-field class=\"hex-input\" floatLabel=\"always\" appearance=\"legacy\" [ngClass]=\"textClass\">\n        <input matInput placeholder=\"HEX\" formControlName=\"hexCode\" />\n      </mat-form-field>\n    </form>\n\n    <form [formGroup]=\"rgbaForm\">\n      <mat-form-field class=\"rgb-input\" floatLabel=\"always\" appearance=\"legacy\" [ngClass]=\"textClass\">\n        <input matInput type=\"number\" [placeholder]=\"colorPickerCollectionService.alpha ? 'RGBA' : 'RGB'\" formControlName=\"R\" />\n      </mat-form-field>\n      <mat-form-field class=\"rgb-input\" floatLabel=\"always\" appearance=\"legacy\" [ngClass]=\"textClass\">\n        <input matInput type=\"number\" formControlName=\"G\" />\n      </mat-form-field>\n      <mat-form-field class=\"rgb-input\" floatLabel=\"always\" appearance=\"legacy\" [ngClass]=\"textClass\">\n        <input matInput type=\"number\" formControlName=\"B\" />\n      </mat-form-field>\n\n      <mat-form-field\n        *ngIf=\"colorPickerCollectionService.alpha\"\n        class=\"rgb-input\"\n        floatLabel=\"always\"\n        appearance=\"legacy\"\n        [ngClass]=\"textClass\"\n      >\n        <input matInput type=\"number\" formControlName=\"A\" />\n      </mat-form-field>\n    </form>\n  </ng-container>\n</div>\n", preserveWhitespaces: false, changeDetection: ChangeDetectionStrategy.OnPush, styles: ["canvas#alpha,canvas#colors{margin:5px}canvas:hover{cursor:crosshair}.mcc-picker-selector{cursor:crosshair;left:0;position:absolute;top:0;z-index:10}.mcc-picker-position{background:rgba(0,0,0,.3);border:1px solid #ddd;border-radius:50%;height:10px;position:absolute;width:10px;z-index:1}.mcc-colors-position{background-image:url(\"data:image/gif;base64,R0lGODdhHgAIALMAAAAAADU1NTk5OUJCQkpKSlZWVltbW2pqaoCAgP///wAAAAAAAAAAAAAAAAAAAAAAACH5BAkAAAoALAAAAAAeAAgAAAQw0BhFq734yjJm/p8xFEVAeGCqGERACmahgkUrvPH81cFdnjoQy8VBBTOiguSokkQAADs=\");background-repeat:no-repeat;position:absolute;right:0;top:0;width:30px;z-index:1}.mcc-colors-position.alpha-enabled{right:40px}.mcc-alpha-position{background-image:url(\"data:image/gif;base64,R0lGODdhHgAIALMAAAAAADU1NTk5OUJCQkpKSlZWVltbW2pqaoCAgP///wAAAAAAAAAAAAAAAAAAAAAAACH5BAkAAAoALAAAAAAeAAgAAAQw0BhFq734yjJm/p8xFEVAeGCqGERACmahgkUrvPH81cFdnjoQy8VBBTOiguSokkQAADs=\");background-repeat:no-repeat;position:absolute;right:5px;top:0;width:30px;z-index:1}.mcc-alpha-background{background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2 2\"><path d=\"M1 2V0h1v1H0v1z\" fill-opacity=\"0.1\"/></svg>');background-repeat:repeat;background-size:14px;bottom:0;left:0;position:absolute;right:0;top:0}.mcc-color-picker-selector{height:170px}::ng-deep mat-form-field{font-size:11px;font-weight:700}::ng-deep mat-form-field.black,::ng-deep mat-form-field.black label.mat-form-field-label{color:rgba(0,0,0,.87)!important}::ng-deep mat-form-field.black .mat-form-field-underline{background-color:rgba(0,0,0,.87)!important}::ng-deep mat-form-field.white,::ng-deep mat-form-field.white label.mat-form-field-label{color:#fff!important}::ng-deep mat-form-field.white .mat-form-field-underline{background-color:#fff!important}.mcc-color-picker-selector-preview{background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2 2\"><path d=\"M1 2V0h1v1H0v1z\" fill-opacity=\"0.1\"/></svg>');background-repeat:repeat;background-size:14px;border-bottom:1px solid #e1e1e1;box-sizing:content-box;height:40px;padding:15px;position:relative}.mcc-color-picker-selector-preview .mcc-color-picker-selector-preview-background{bottom:0;left:0;position:absolute;right:0;top:0}.mcc-color-picker-selector-preview form{display:inline-block;position:relative}.mcc-color-picker-selector-preview form input::-webkit-inner-spin-button,.mcc-color-picker-selector-preview form input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.mcc-color-picker-selector-preview form input[type=number]{-moz-appearance:textfield}.mcc-color-picker-selector-preview .hex-input{margin-right:20px;width:86px}.mcc-color-picker-selector-preview .hex-input input{font-size:16px;font-weight:400}.mcc-color-picker-selector-preview .rgb-input{margin-right:4px;width:32px}.mcc-color-picker-selector-preview .rgb-input input{font-size:16px;font-weight:400}"] }]
    }], function () { return [{ type: ɵngcc5.FormBuilder }, { type: ɵngcc0.Renderer2 }, { type: MccColorPickerCollectionService }, { type: String, decorators: [{
                type: Inject,
                args: [EMPTY_COLOR]
            }] }]; }, { changeSelectedColor: [{
            type: Output
        }], hueContainer: [{
            type: ViewChild,
            args: ['hueContainer']
        }], height: [{
            type: Input
        }], selectedColor: [{
            type: Input
        }], hideHexForms: [{
            type: Input
        }], _block: [{
            type: ViewChild,
            args: ['block']
        }], _bp: [{
            type: ViewChild,
            args: ['blockPointer']
        }], _bc: [{
            type: ViewChild,
            args: ['blockCanvas']
        }], _hueSelector: [{
            type: ViewChild,
            args: ['hueSelector']
        }], _alpha: [{
            type: ViewChild,
            args: ['alpha']
        }], _ac: [{
            type: ViewChild,
            args: ['alphaContainer']
        }] }); })();

/**
 * This directive change the background of the button
 */
class MccColorPickerOptionComponent {
    constructor(render, emptyColor, selectedColorIcon, selectedColorSvgIcon, disableSelectedIcon) {
        this.render = render;
        this.emptyColor = emptyColor;
        this.selectedColorIcon = selectedColorIcon;
        this.selectedColorSvgIcon = selectedColorSvgIcon;
        this.disableSelectedIcon = disableSelectedIcon;
        this.colorSelected = new EventEmitter();
        this._color = emptyColor;
    }
    /**
     * Receive the color
     */
    get color() {
        return this._color;
    }
    set color(value) {
        this._color = value;
    }
    get ariaLabel() {
        if (!this.color) {
            return null;
        }
        let colorName;
        if (typeof this.color === 'string') {
            colorName = this.color;
        }
        else {
            colorName = this.color.text;
        }
        return colorName;
    }
    get backgroundColor() {
        if (!this.color) {
            return null;
        }
        let color;
        if (typeof this.color === 'string') {
            color = this.color;
        }
        else {
            color = this.color.text;
        }
        if (parseColorString(color)) {
            return color;
        }
    }
    /**
     * returns class for "black" or "white" icon-color on a collection-item
     */
    getIconColorClassForColor(color) {
        const colorString = typeof color === 'string' ? color : color.value;
        const clr = parseColorString(colorString);
        if (clr) {
            return clr.isDark() && clr.getAlpha() > 0.3 ? 'white' : 'black';
        }
    }
    /**
     * check if a color is the current selected color
     */
    isColorSelected(color) {
        if (!color) {
            return false;
        }
        if (typeof color === 'string') {
            return this.selectedColor === color;
        }
        else {
            return this.selectedColor === color.value;
        }
    }
}
MccColorPickerOptionComponent.ɵfac = function MccColorPickerOptionComponent_Factory(t) { return new (t || MccColorPickerOptionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(EMPTY_COLOR), ɵngcc0.ɵɵdirectiveInject(SELECTED_COLOR_ICON), ɵngcc0.ɵɵdirectiveInject(SELECTED_COLOR_SVG_ICON), ɵngcc0.ɵɵdirectiveInject(DISABLE_SELECTED_COLOR_ICON)); };
MccColorPickerOptionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MccColorPickerOptionComponent, selectors: [["mcc-color-picker-option"]], viewQuery: function MccColorPickerOptionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c11, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.button = _t.first);
    } }, inputs: { color: "color", selectedColor: "selectedColor" }, outputs: { colorSelected: "colorSelected" }, decls: 4, vars: 5, consts: [["mat-mini-fab", "", "role", "option", 1, "mat-elevation-z0", "option-background", 3, "disabled", "click"], ["button", ""], [1, "option-color"], [4, "ngIf"], [4, "ngIf", "ngIfElse"], ["selectionIcon", ""], ["class", "mat-svg-icon", 3, "svgIcon", "ngClass", 4, "ngIf", "ngIfElse"], ["selectionFontIcon", ""], [1, "mat-svg-icon", 3, "svgIcon", "ngClass"], ["class", "mat-font-icon", 3, "ngClass", 4, "ngIf"], [1, "mat-font-icon", 3, "ngClass"]], template: function MccColorPickerOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0, 1);
        ɵngcc0.ɵɵlistener("click", function MccColorPickerOptionComponent_Template_button_click_0_listener() { return ctx.colorSelected.emit(ctx.color); });
        ɵngcc0.ɵɵelement(2, "span", 2);
        ɵngcc0.ɵɵtemplate(3, MccColorPickerOptionComponent_ng_container_3_Template, 4, 2, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("disabled", !ctx.color || ctx.color === ctx.emptyColor);
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("background-color", ctx.backgroundColor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.disableSelectedIcon);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc2.MatButton, ɵngcc8.MatIcon], styles: ["button[_ngcontent-%COMP%]{cursor:pointer;height:22px;margin:3px;width:22px}button[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{position:relative}button[_ngcontent-%COMP%]   mat-icon.black[_ngcontent-%COMP%]{color:rgba(0,0,0,.87)!important;fill:rgba(0,0,0,.87)!important}button[_ngcontent-%COMP%]   mat-icon.white[_ngcontent-%COMP%]{color:#fff!important;fill:#fff!important}button.black[_ngcontent-%COMP%], button.black[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{color:rgba(0,0,0,.87)!important}button.white[_ngcontent-%COMP%], button.white[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{color:#fff!important}button[_ngcontent-%COMP%]   .mat-font-icon[_ngcontent-%COMP%]{font-size:.8rem;font-weight:600;height:10px;margin:-1.3rem 0 0 -.15rem;width:10px}button[_ngcontent-%COMP%]   .mat-svg-icon[_ngcontent-%COMP%]{margin:-1.3rem 0 0;width:14px}.option-background[_ngcontent-%COMP%]{background-color:transparent!important;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2 2\"><path d=\"M1 2V0h1v1H0v1z\" fill-opacity=\"0.1\"/></svg>');background-repeat:repeat;background-size:14px;position:relative}.option-color[_ngcontent-%COMP%]{background-color:#d3d3d3;border-radius:12px;bottom:0;left:0;position:absolute;right:0;top:0}"], changeDetection: 0 });
MccColorPickerOptionComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: String, decorators: [{ type: Inject, args: [EMPTY_COLOR,] }] },
    { type: String, decorators: [{ type: Inject, args: [SELECTED_COLOR_ICON,] }] },
    { type: String, decorators: [{ type: Inject, args: [SELECTED_COLOR_SVG_ICON,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [DISABLE_SELECTED_COLOR_ICON,] }] }
];
MccColorPickerOptionComponent.propDecorators = {
    color: [{ type: Input }],
    selectedColor: [{ type: Input }],
    colorSelected: [{ type: Output }],
    button: [{ type: ViewChild, args: ['button',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MccColorPickerOptionComponent, [{
        type: Component,
        args: [{ selector: 'mcc-color-picker-option', template: "<button\n  #button\n  mat-mini-fab\n  role=\"option\"\n  [attr.aria-label]=\"ariaLabel\"\n  class=\"mat-elevation-z0 option-background\"\n  [disabled]=\"!color || color === emptyColor\"\n  (click)=\"colorSelected.emit(color)\"\n>\n  <span class=\"option-color\" [style.backgroundColor]=\"backgroundColor\"></span>\n\n  <ng-container *ngIf=\"!disableSelectedIcon\">\n    <mat-icon *ngIf=\"!isColorSelected(color); else selectionIcon\"></mat-icon>\n    <ng-template #selectionIcon>\n      <mat-icon\n        *ngIf=\"selectedColorSvgIcon; else selectionFontIcon\"\n        class=\"mat-svg-icon\"\n        [svgIcon]=\"selectedColorSvgIcon\"\n        [ngClass]=\"getIconColorClassForColor(color)\"\n      ></mat-icon>\n      <ng-template #selectionFontIcon>\n        <mat-icon *ngIf=\"!selectedColorSvgIcon\" class=\"mat-font-icon\" [ngClass]=\"getIconColorClassForColor(color)\">{{\n          selectedColorIcon\n        }}</mat-icon>\n      </ng-template>\n    </ng-template>\n  </ng-container>\n</button>\n", preserveWhitespaces: false, changeDetection: ChangeDetectionStrategy.OnPush, styles: ["button{cursor:pointer;height:22px;margin:3px;width:22px}button mat-icon{position:relative}button mat-icon.black{color:rgba(0,0,0,.87)!important;fill:rgba(0,0,0,.87)!important}button mat-icon.white{color:#fff!important;fill:#fff!important}button.black,button.black mat-icon{color:rgba(0,0,0,.87)!important}button.white,button.white mat-icon{color:#fff!important}button .mat-font-icon{font-size:.8rem;font-weight:600;height:10px;margin:-1.3rem 0 0 -.15rem;width:10px}button .mat-svg-icon{margin:-1.3rem 0 0;width:14px}.option-background{background-color:transparent!important;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2 2\"><path d=\"M1 2V0h1v1H0v1z\" fill-opacity=\"0.1\"/></svg>');background-repeat:repeat;background-size:14px;position:relative}.option-color{background-color:#d3d3d3;border-radius:12px;bottom:0;left:0;position:absolute;right:0;top:0}"] }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: String, decorators: [{
                type: Inject,
                args: [EMPTY_COLOR]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [SELECTED_COLOR_ICON]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [SELECTED_COLOR_SVG_ICON]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [DISABLE_SELECTED_COLOR_ICON]
            }] }]; }, { colorSelected: [{
            type: Output
        }], color: [{
            type: Input
        }], selectedColor: [{
            type: Input
        }], button: [{
            type: ViewChild,
            args: ['button']
        }] }); })();

const ɵ0 = [];
class MccColorPickerModule {
    /**
     *
     */
    static forRoot(config) {
        return {
            ngModule: MccColorPickerModule,
            providers: [
                { provide: DISABLE_SELECTED_COLOR_ICON, useValue: config.disable_selected_icon || false },
                { provide: ENABLE_ALPHA_SELECTOR, useValue: config.enable_alpha_selector || false },
                { provide: SELECTED_COLOR_ICON, useValue: config.selected_icon || 'done' },
                { provide: SELECTED_COLOR_SVG_ICON, useValue: config.selected_svg_icon || null },
                { provide: EMPTY_COLOR, useValue: 'empty_color' in config ? config.empty_color : 'none' },
                { provide: USED_COLORS, useValue: config.used_colors || [] },
                { provide: COLOR_STRING_FORMAT, useValue: config.color_string_format || 'hex' }
            ]
        };
    }
}
MccColorPickerModule.ɵfac = function MccColorPickerModule_Factory(t) { return new (t || MccColorPickerModule)(); };
MccColorPickerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MccColorPickerModule });
MccColorPickerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        MccColorPickerService,
        { provide: DISABLE_SELECTED_COLOR_ICON, useValue: false },
        { provide: ENABLE_ALPHA_SELECTOR, useValue: false },
        { provide: SELECTED_COLOR_ICON, useValue: 'done' },
        { provide: SELECTED_COLOR_SVG_ICON, useValue: null },
        { provide: EMPTY_COLOR, useValue: 'none' },
        { provide: USED_COLORS, useValue: ɵ0 },
        { provide: COLOR_STRING_FORMAT, useValue: 'hex' }
    ], imports: [CommonModule,
        PortalModule,
        OverlayModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MccColorPickerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    PortalModule,
                    OverlayModule,
                    ReactiveFormsModule,
                    MatButtonModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatIconModule
                ],
                declarations: [
                    MccColorPickerComponent,
                    MccConnectedColorPickerDirective,
                    MccColorPickerSelectorComponent,
                    MccColorPickerOriginDirective,
                    MccColorPickerOptionComponent,
                    MccColorPickerCollectionComponent
                ],
                exports: [MccColorPickerComponent, MccConnectedColorPickerDirective, MccColorPickerOriginDirective, MccColorPickerCollectionComponent],
                providers: [
                    MccColorPickerService,
                    { provide: DISABLE_SELECTED_COLOR_ICON, useValue: false },
                    { provide: ENABLE_ALPHA_SELECTOR, useValue: false },
                    { provide: SELECTED_COLOR_ICON, useValue: 'done' },
                    { provide: SELECTED_COLOR_SVG_ICON, useValue: null },
                    { provide: EMPTY_COLOR, useValue: 'none' },
                    { provide: USED_COLORS, useValue: ɵ0 },
                    { provide: COLOR_STRING_FORMAT, useValue: 'hex' }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MccColorPickerModule, { declarations: function () { return [MccColorPickerComponent, MccConnectedColorPickerDirective, MccColorPickerSelectorComponent, MccColorPickerOriginDirective, MccColorPickerOptionComponent, MccColorPickerCollectionComponent]; }, imports: function () { return [CommonModule,
        PortalModule,
        OverlayModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule]; }, exports: function () { return [MccColorPickerComponent, MccConnectedColorPickerDirective, MccColorPickerOriginDirective, MccColorPickerCollectionComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { COLOR_STRING_FORMAT, DISABLE_SELECTED_COLOR_ICON, EMPTY_COLOR, ENABLE_ALPHA_SELECTOR, MccColorPickerCollectionComponent, MccColorPickerCollectionService, MccColorPickerComponent, MccColorPickerModule, MccColorPickerOptionComponent, MccColorPickerOriginDirective, MccColorPickerSelectorComponent, MccColorPickerService, MccConnectedColorPickerDirective, SELECTED_COLOR_ICON, SELECTED_COLOR_SVG_ICON, USED_COLORS, ɵ0 };

